module.exports = __webpack_public_path__ + "static/media/partner-purple.d5ba85df.svg";